import React from "react";
import CustomTable from "../customTable";
import { ResultsPerMonthColumns } from "./columns/ResultsPerMonthColumns";
import Comments from "../comments";

const ResultsPerMonth = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <CustomTable
        columns={ResultsPerMonthColumns}
        data={processedData?.results_per_month?.data || []}
        totalAggregatedData={processedData?.results_per_month?.totals || {}}
        loading={loading}
        storageKey={"resultspermonth"}
      />
      <Comments tab_name="Results per month" />
    </div>
  );
};

export default ResultsPerMonth;
